import React from 'react'
import { Navigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { UsersSettingsPage as SharedUsersSettingsPage } from '@darwin-launchpad/legacy-shared/app-settings'
import { useAuth } from '../contexts/IframeAuthProvider'
import { getUsersSettingsApi, useCanManageUsersSettings } from '../lib/usersSettings'
import './UsersSettingsPage.css'

/** `/settings/users`: the shared Users page, or a redirect home when it is off. */
export const UsersSettingsPage: React.FC = () => {
  const { authTenantId } = useAuth()
  const allowed = useCanManageUsersSettings()
  // Not mounted at all when blocked, so no membership request is sent.
  if (!allowed) return <Navigate to="/dashboard" replace />

  const api = getUsersSettingsApi()
  return (
    <div className="p-8 max-w-6xl mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 tracking-tight">Settings</h1>
      </div>
      {api ? (
        // Keyed by tenant so switching organizations reloads the member list.
        <SharedUsersSettingsPage key={authTenantId} api={api} notify={toast} className="bc-users-settings" />
      ) : (
        <p role="alert" className="text-sm text-red-600">
          User management is not configured. Contact your administrator.
        </p>
      )}
    </div>
  )
}
